import React, { PureComponent } from "react";
import styled from 'styled-components';

import { decimalsRound } from "../../services/utils";
import Teams from "../../api/Teams";

const BarWrapper = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  div {
    font-family: 'Mukta Vaani';
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: hsla(213, 100%, 12%, 0.6);
    text-align: right;
  }

  border-right: 2px solid #8794a3;
  gap: 18px;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 5px;
`;

const ValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 18px;
  flex: 1;
  margin-right: 40px;
`;

const BarValue = styled.div`
  height: 24px;
  width: 0;
  transition: width 0.6s ease-in-out;

  ${p => p.width && `
    width: ${p.width}%;
  `}

  ${p => p.background && `
    background: ${p.background};
  `}

  span {
    font-family: Roboto;
    font-size: 11px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 1px;
    color: hsla(213, 100%, 12%, 0.94);
    position: relative;
    left: calc(100% + 5px);
  }
`;

class BarValueAnimated extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      delayed: props.width,
      color: props.color,
      animated: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        width: this.state.delayed,
      }, () => {
        setTimeout(() => {
          this.setState({
            animated: true,
          });
        }, 600);
      });
    }, 700);
  }

  render() {
    const { color, width, animated } = this.state;

    return (
      <BarValue
        background={color}
        width={width}
      >
        {animated && <span>{width}%</span>}
      </BarValue>
    )
  }
}

class DashboardBarChart extends PureComponent {
  render() {
    const { teamGradings: rawTeamGradings, round_number } = this.props;

    const currentTeam = Teams.currentTeam();
    const teamGradings = rawTeamGradings.results;
    const currentGrading = teamGradings.find(
      item => (
        Number(item.round_number) === Number(round_number) &&
        Number(item.team) === Number(currentTeam.id)
      )
    ) || {
      weighted_value: 0,
      highest_weighted_value: 0,
      median_weighted_value: 0,
      average_weighted_value: 0,
    };

    const {
      weighted_value,
      highest_weighted_value,
      median_weighted_value,
      average_weighted_value
    } = currentGrading;

    const teamColor = Teams.currentTeamColorLevel3();

    const data = [
      {
        name: "Team",
        value: Number(decimalsRound(weighted_value * 100, 2)),
        color: teamColor
      },
      {
        name: "Highest",
        value: Number(decimalsRound(highest_weighted_value * 100, 2)),
        color: "hsla(213, 100%, 12%, 0.8)"
      },
      {
        name: "Median",
        value: Number(decimalsRound(median_weighted_value * 100, 2)),
        color: "hsla(213, 100%, 12%, 0.45)"
      },
      {
        name: "Average",
        value: Number(decimalsRound(average_weighted_value * 100, 2)),
        color: "hsla(213, 100%, 12%, 0.2)"
      }
    ];

    return (
      <div>
        <BarWrapper>
          <TextWrapper>
            {data.map(({ name }, index) => (
              <div key={`bar-chart-text-${index}`}>{name}</div>
            ))}
          </TextWrapper>
          <ValueWrapper>
            {data.map(({ value, color }, index) => (
              <BarValueAnimated
                key={`bar-chart-value-${index}`}
                color={color}
                width={value}
              />
            ))}
          </ValueWrapper>
        </BarWrapper>
      </div>
    );
  }
}

export default DashboardBarChart;



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardBarChart.js